module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "section-label"
    }
  }, [_c('div', {
    staticClass: "reveal-label"
  }, [_c('div', {
    staticClass: "reveal-block"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.home_section_1_title_menu")))])]), _vm._v(" "), _c('div', {
    staticClass: "reveal-label"
  }, [_c('div', {
    staticClass: "reveal-block"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.home_section_2_title_menu")))])]), _vm._v(" "), _c('div', {
    staticClass: "reveal-label"
  }, [_c('div', {
    staticClass: "reveal-block"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.home_section_3_title_menu")))])]), _vm._v(" "), _c('div', {
    staticClass: "reveal-label"
  }, [_c('div', {
    staticClass: "reveal-block"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("message.home_section_4_title_menu")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67444841","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SectionLabel.vue
// module id = 69
// module chunks = 0